import { useQuery } from '@tanstack/react-query';
import api from '../services/api';

// The working behind a van's stock figures, for going through with an engineer
// who says his stock is wrong.
export function useReconcileVans() {
  return useQuery({
    queryKey: ['vanReconcile', 'vans'],
    queryFn: async () => (await api.get('/api/van-requests/reconcile/vans')).data.vans,
    staleTime: 300000,
  });
}

export function useVanReconcile(registration) {
  return useQuery({
    queryKey: ['vanReconcile', 'detail', registration || ''],
    queryFn: async () => (await api.get(
      `/api/van-requests/reconcile/${encodeURIComponent(registration)}`)).data,
    enabled: !!registration,
    staleTime: 0,
  });
}

// The movements behind one item, newest first, a page at a time. Kept separate
// from the van summary because this is the part that grows without limit.
export function useItemMovements(registration, stockItemId, { limit = 25, offset = 0 } = {}) {
  return useQuery({
    queryKey: ['vanReconcile', 'movements', registration || '', String(stockItemId || ''), limit, offset],
    queryFn: async () => (await api.get(
      `/api/van-requests/reconcile/${encodeURIComponent(registration)}/item/${stockItemId}`
      + `?limit=${limit}&offset=${offset}`)).data,
    enabled: !!registration && !!stockItemId,
    keepPreviousData: true,
    staleTime: 0,
  });
}
